import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, extractError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        toast.success("Signed in with Google");
        navigate("/dashboard", { state: { user: data.user } });
      } catch (e) {
        setError(extractError(e));
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="grain-overlay" aria-hidden />
      <div className="text-center" data-testid="auth-callback">
        <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4 text-primary" />
        <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Finishing sign-in</div>
        {error && <div className="text-destructive mt-3 text-sm">{error}</div>}
      </div>
    </div>
  );
}
